export default __webpack_public_path__ + "bb58e57c48a3e911f15fa834ff00d44a.woff";